

export const USER_ACCOUNT_ROLE_LANDLORD = 'landlord';
export const USER_ACCOUNT_ROLE_TENANT = 'tenant';
export const USER_ACCOUNT_ROLE_BROKER = 'broker';

export const USER_ACCOUNT_ROLE_ADMIN = 'admin';

export const STARTUP_BANK_ACCOUNT_READ_LIMIT = 20;
export const STARTUP_WITHDRAWALS_READ_LIMIT = 20;